// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_l74","cls2":"FocusedNav-cls2_72Q FocusedNav-cls1_l74","isMobileNav":"FocusedNav-isMobileNav_Rgk"};